import React from "react";
import { Modal, Button, Row, Col, Container, Accordion } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import AccountImg from "../../../../../assets/images/Account.png";
import {
  IconSeqarrow,
  IconPlanUpgrade2,
  IconleftArrow,
} from "../../../../../icons/Icons";
import UserImage from "../../../../../components/UserImage/UserImage";
import getInitialsInName from "../../../../../helper/GetNameInitials";
import { useEffect, useState } from "react";
import Loader from "../../../../../components/Loader/Loader";
import { Link } from "react-router-dom";
const AccountOnboarding = ({ onClose, teamStatus, formDataReady }) => {
  const currentMemberTabTitle = `Currently Onboarding (${
    teamStatus?.currentMembers?.length || 0
  })`;
  const pendingTabTitle = `Pending (${
    teamStatus?.pendingMembers?.length || 0
  })`;
  const upcomingMembersTabTitle = `Upcoming (${
    teamStatus?.upcomingMembers?.length || 0
  })`;
  const completedMembers = `Completed (${
    teamStatus?.completedMembers?.length || 0
  })`;

  const [activeTab, setActiveTab] = useState("CurrentMembers");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  console.log(activeTab, "11");
  return (
    <>
      <Modal.Header className="ps-80 bg-base-100">
        <div className="w-100 d-flex justify-content-start align-items-center">
          <Modal.Title>Account Onboarding</Modal.Title>
          <ul
            class="modalTab modalTab authoringNav p-0 bg-base-100 nav"
            role="tablist"
            style={{ marginBottom: "-2.438rem", marginLeft: "3.75rem" }}
          >
            <li className="nav-item">
              <Link
                className={`h6 text-gray-100 ${
                  activeTab === "CurrentMembers" ? "active" : ""
                }`}
                onClick={() => handleTabClick("CurrentMembers")}
              >
                {currentMemberTabTitle}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`h6 text-gray-100 ${
                  activeTab === "Pending" ? "active" : ""
                }`}
                onClick={() => handleTabClick("Pending")}
              >
                {pendingTabTitle}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`h6 text-gray-100 ${
                  activeTab === "Upcoming" ? "active" : ""
                }`}
                onClick={() => handleTabClick("Upcoming")}
              >
                {upcomingMembersTabTitle}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`h6 text-gray-100 ${
                  activeTab === "Completed" ? "active" : ""
                }`}
                onClick={() => handleTabClick("Completed")}
              >
                {completedMembers}
              </Link>
            </li>
          </ul>
          <button
            onClick={() => onClose(false)}
            type="button"
            class="btn-close"
            aria-label="Close"
          ></button>
        </div>
      </Modal.Header>
      <Modal.Body className="bg-gray-600 ps-80">
        <div className="">
          {activeTab === "CurrentMembers" ? (
            <>
              {formDataReady === false && <Loader />}
              <div className="">
                {teamStatus?.currentMembers.map((item) => (
                  <div className="d-flex gap-2 align-items-center mb-3 pb-1">
                    {item.img ? (
                      <div className="headImg">
                        {/*   <img src={AccountImg} alt="" /> */}
                        <UserImage imgKey={item.img} />
                      </div>
                    ) : (
                      <div>
                        <div className="headImg">
                          <img
                            src={getInitialsInName(item.name ?? "N A", 36)}
                            alt={item.name}
                          />
                        </div>
                      </div>
                    )}
                    <div>
                      <h5 className="font-medium">
                        {item.name} <span className="text-primary-100">({item.role})</span>
                      </h5>
                    </div>
                  </div>
                ))}
                {/* <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div> */}
              </div>
            </>
          ) : activeTab === "Pending" ? (
            <>
              {formDataReady === false && <Loader />}
              <div className="">
                {teamStatus?.pendingMembers.map((item) => (
                  <div className="d-flex gap-2 align-items-center mb-3 pb-1">
                    {item.img ? (
                      <div className="headImg">
                        {/*   <img src={AccountImg} alt="" /> */}
                        <UserImage imgKey={item.img} />
                      </div>
                    ) : (
                      <div>
                        <div className="headImg">
                          <img
                            src={getInitialsInName(item.name ?? "N A", 36)}
                            alt={item.name}
                          />
                        </div>
                      </div>
                    )}
                    <div>
                      <h5 className="font-medium">
                        {item.name} <span className="text-primary-100">({item.role})</span>
                      </h5>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : activeTab === "Upcoming" ? (
            <>
              {formDataReady === false && <Loader />}
              <div className="">
                {teamStatus?.upcomingMembers.map((item) => (
                  <div className="d-flex gap-2 align-items-center mb-3 pb-1">
                    {item.img ? (
                      <div className="headImg">
                        {/*   <img src={AccountImg} alt="" /> */}
                        <UserImage imgKey={item.img} />
                      </div>
                    ) : (
                      <div>
                        <div className="headImg">
                          <img
                            src={getInitialsInName(item.name ?? "N A", 36)}
                            alt={item.name}
                          />
                        </div>
                      </div>
                    )}
                    <div>
                      <h5 className="font-medium">
                        {item.name} <span className="text-primary-100">({item.role})</span>
                      </h5>
                    </div>
                  </div>
                ))}
                {/* <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div> */}
              </div>
            </>
          ) : activeTab === "Completed" ? (
            <>
              {formDataReady === false && <Loader />}
              <div className="">
                {teamStatus?.completedMembers.map((item) => (
                  <div className="d-flex gap-2 align-items-center mb-3 pb-1">
                    {item.img ? (
                      <div className="headImg">
                        {/*   <img src={AccountImg} alt="" /> */}
                        <UserImage imgKey={item.img} />
                      </div>
                    ) : (
                      <div>
                        <div className="headImg">
                          <img
                            src={getInitialsInName(item.name ?? "N A", 36)}
                            alt={item.name}
                          />
                        </div>
                      </div>
                    )}
                    <div>
                      <h5 className="font-medium">
                        {item.name} <span className="text-primary-100">({item.role})</span>
                      </h5>
                    </div>
                  </div>
                ))}
                {/* <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div>
        <div className="d-flex gap-2 align-items-center mb-3 pb-1">
           <div className="headImg">
              <img src={AccountImg} alt="" />
            </div>
            <div>
              <h6 className="font-medium">John Smith</h6>
            </div>
        </div> */}
              </div>
            </>
          ) : null}
        </div>
      </Modal.Body>
    </>
  );
};

export default AccountOnboarding;
